import React from "react";
import "../style/newApplication.css";
import FormResponseMessage from "./formResponseMessage";
import "../style/dots.css";
import Button from "./button";
import moment from "moment";
import _ from "lodash";
import { Link } from "react-router-dom";
import { isAragUser, isSolicitorUser } from "../helpers/functions";
import {
  APPLICATION_FORM_FIELDS,
  LEGAL_ADVICE_TEXT,
  WORK_SOURCE_EDIT_MESSAGE,
} from "../helpers/variables";
import CustomModal from "./General/customModal";
import PremiumSettingsWizardHOC from "../containers/PremiumSettings/premiumSettingsWizardHOC";
import DeleteAnswerModal from "./ApplicationPolicy/deleteAnswerModal";
import CenteredDots from "./General/centeredDots";
import { checkIfQuestionHasPendingChanges } from "../helpers/questions/functions";
import FormQuestionAnswerRevisions from "./ApplicationPolicy/formQuestionAnswerRevisions";
import PlainApplicationForm from "./applicationForm/plainApplicationForm";
import FullApplicationForm from "./applicationForm/fullApplicationForm";
import AnswerEditModal from "./applicationForm/answerEditModal";
import CalendarModal from "./applicationForm/calendarModal";
import CaseForm from "./applicationForm/caseForm";
import FormGroupSelectInput from "./formGroupSelectInput";
import { HorizontalRule } from "arag-ui-lib";
import ApplicationPremiumSettingsHOC from "../containers/ApplicationPremiumSettings/applicationPremiumSettingsHOC";
import { SHOW_APPLICATION_PREMIUM_STATUSES } from "../helpers/constants";

const NewApplication = (props) => {
  const {
    isDeleteAnswerModalOpen,
    closeDeleteAnswerModal,
    onDeleteAnswerConfirm,
    isHistoryModalOpen,
    closeHistoryModal,
    historyItem,
  } = props;
  if (
    isSolicitorUser(props.user.loggedInUser.roles) &&
    !props.user.loggedInUser.allowedToCreateApplications &&
    props.router.location.pathname === "/new-application"
  ) {
    return (
      <div className={"row"}>
        <FormResponseMessage
          CenterWrapper="col-sm-12 mb-15"
          MessageStyle="formResponseMessage-reject"
          Message={
            "Application creation in not permitted for this account. Please contact ARAG " +
            "for more information."
          }
        />
      </div>
    );
  }
  const caseTypeOptions = [
    { key: "", value: "None" },
    ...props.Store.caseTypes.map((caseType) => {
      return { key: caseType.id, value: caseType.name };
    }),
  ];
  const subCaseTypeOptions = [
    { key: "", value: "None" },
    ..._.filter(props.Store.subCaseTypes, (subCase) => {
      return subCase.caseTypeId.toString() === props.Store.selectedCaseType;
    }).map((subCaseType) => {
      return { key: subCaseType.id, value: subCaseType.name };
    }),
  ];
  const maxDateOfBirth = moment().format("DD/MM/YYYY");
  let workSourceOptions = [{ key: "", value: "" }];
  if (props.Store.solicitorGroupWorkSources.length > 0) {
    workSourceOptions = [
      ...workSourceOptions,
      ...props.Store.solicitorGroupWorkSources.map((option) => {
        return { key: option.id, value: option.name };
      }),
    ];
  }

  return (
    <div className="row">
      {props.Store.selectedApplication &&
        props.Store.selectedApplication.id &&
        checkIfQuestionHasPendingChanges(
          null,
          props.Store.selectedApplication,
          APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName
        ) && (
          <div className={"col-sm-12 mt-15"}>
            <div className={"form-horizontal"}>
              <FormResponseMessage
                Message={WORK_SOURCE_EDIT_MESSAGE}
                CenterWrapper={"col-sm-12"}
                MessageStyle={"formResponseMessage-info"}
              />
            </div>
          </div>
        )}

      <DeleteAnswerModal
        isOpen={isDeleteAnswerModalOpen}
        onClose={closeDeleteAnswerModal}
        onConfirm={onDeleteAnswerConfirm}
        isLoading={props.Store.updatingQuestionAnswer}
        errorMessage={props.Store.updatingQuestionAnswerFail}
      />

      <CustomModal
        contentClassname={
          props.Store.questionAnswerForEdit &&
          props.Store.questionAnswerForEdit.machineName ===
            "EstimateForMedicalExpertFees"
            ? "tobas__toba-modal"
            : ""
        }
        modelDepth={3}
        isOpen={isHistoryModalOpen}
        content={
          <FormQuestionAnswerRevisions
            breachCausationCpOptions={props.breachCausationCp.options}
            solicitorGroupWorkSources={props.Store.solicitorGroupWorkSources}
            historyItem={historyItem}
            application={props.Store.selectedApplication}
          />
        }
        handleClose={closeHistoryModal}
      />
      <AnswerEditModal {...props} />
      {isSolicitorUser(props.user.loggedInUser.roles) &&
        !props.user.loggedInUser.toba &&
        props.router.location.pathname === "/new-application" &&
        !props.Store.getApplicationFromErrorMessage && (
          <FormResponseMessage
            CenterWrapper="col-sm-12"
            MessageStyle="formResponseMessage-reject"
            Message={
              <div>
                <span>
                  {"Please accept the latest "}
                  <Link to={"/accept-toba"}>{"TOBA"}</Link>
                  {" in order to be able to create a new application"}
                </span>
              </div>
            }
          />
        )}
      <div className="col-sm-12 newApplication-wrapper">
        <CalendarModal {...props} />
        {props.Store.fetchingSelectedApp ? (
          <div className="form-group">
            <div className="col-sm-12">
              <CenteredDots />
            </div>
          </div>
        ) : (
          <div>
            <div className="row">
              {Object.keys(props.Store.selectedApplication).length !== 0 &&
              props.Store.selectedApplication.constructor === Object ? null : (
                <h2 className="col-sm-12 applicationsAndPolicies-h2">
                  Create New Application
                </h2>
              )}
            </div>
            <div className="row">
              {Object.keys(props.Store.selectedApplication).length !== 0 &&
              props.Store.selectedApplication.constructor === Object ? null : (
                <p className="col-sm-10">
                  {props.newApplicationFormMessage.applicationFormMessage
                    ? props.newApplicationFormMessage.applicationFormMessage
                        .body
                    : null}
                </p>
              )}
            </div>
            <div className={"row mt-15 noprintarea"}>
              {isSolicitorUser(props.user.loggedInUser.roles) ? (
                <div className={"col-sm-12"}>
                  <Button
                    clickHandler={() => window.print()}
                    wrapper="btn-wrapper"
                    btnType="button"
                    btnStyle={"btn btn-primary btn-xs sharp white"}
                    label="Print"
                  />
                </div>
              ) : null}

              {isAragUser(props.user.loggedInUser.roles) &&
              props.router.location.pathname.includes("/new-application") ? (
                <div>
                  <div>
                    {" "}
                    <FormGroupSelectInput
                      Value={props.SolicitorFirms.lawsysFirms
                        .map((value) => value.name)
                        .find(
                          (e) => e.id == props.Store.solicitorFirmIdSelected
                        )}
                      Label={`Select ${LEGAL_ADVICE_TEXT} firm`}
                      LeftWrapper="col-sm-2"
                      Options={[
                        {
                          key: "",
                          value: "None",
                        },
                        ...props.SolicitorFirms.lawsysFirms.map((value) => {
                          return { key: value.id, value: value.name };
                        }),
                      ]}
                      HandleInputChange={(evt) =>
                        props.handleSolicitorFirmSelect(evt.target.value)
                      }
                      CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                      RightWrapper=""
                      SelectStyle={"form-control formGroupSelectInput-select"}
                    />
                  </div>
                  <br></br>

                  {props.Store.solicitorFirmIdSelected !== "" ? (
                    !props.AgentsList.fetching ? (
                      <div>
                        {" "}
                        <FormGroupSelectInput
                          Value={props.AgentsList.allSolicitorUsers.find(
                            (a) => a.id == props.Store.userId
                          )}
                          Label={`Select ${LEGAL_ADVICE_TEXT} user`}
                          LeftWrapper="col-sm-2"
                          Options={[
                            {
                              key: "",
                              value: "None",
                            },
                            ...props.AgentsList.allSolicitorUsers.map(
                              (value) => {
                                return {
                                  key: value.userId,
                                  value: value.username,
                                };
                              }
                            ),
                          ]}
                          HandleInputChange={(evt) =>
                            props.handleSolicitorSelect(evt.target.value)
                          }
                          CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                          RightWrapper=""
                          SelectStyle={
                            "form-control formGroupSelectInput-select"
                          }
                        />
                      </div>
                    ) : (
                      <div className="col-sm-12">
                        <CenteredDots />
                      </div>
                    )
                  ) : null}
                </div>
              ) : null}
            </div>
            {props.Store.userId == "" &&
            isAragUser(props.user.loggedInUser.roles) && 
            props.router.location.pathname.includes("/new-application") ? null : (
              <div>
                <div className="row noprintarea">
                  <div className="col-sm-12">
                    <hr className="appFormRefSettings-hr" />
                  </div>
                </div>
                {!props.groups.fetchingSolicitorGroupCaseTypes ? (
                  <CaseForm
                    {...props}
                    caseTypeOptions={caseTypeOptions}
                    subCaseTypeOptions={subCaseTypeOptions}
                    maxDateOfBirth={maxDateOfBirth}
                    workSourceOptions={workSourceOptions}
                  />
                ) : (
                  <div className="col-sm-12">
                    <CenteredDots />
                  </div>
                )}
                <div className="row">
                  <div className="col-sm-12">
                    <hr className="appFormRefSettings-hr" />
                  </div>
                </div>
              </div>
            )}
            {props.Store.getApplicationFromErrorMessage && (
              <div className={"row"}>
                <FormResponseMessage
                  CenterWrapper="col-sm-12"
                  MessageStyle="formResponseMessage-reject"
                  Message={props.Store.getApplicationFromErrorMessage}
                />
              </div>
            )}
            {Object.keys(props.Store.selectedApplication).length !== 0 &&
            props.Store.selectedApplication.constructor === Object &&
            (props.Store.selectedApplication.policyStatus !== "Draft" ||
              props.UserRole !== "Solicitor") ? (
              <div className="">
                <PlainApplicationForm
                  {...props}
                  caseTypeOptions={caseTypeOptions}
                  subCaseTypeOptions={subCaseTypeOptions}
                  maxDateOfBirth={maxDateOfBirth}
                  workSourceOptions={workSourceOptions}
                />
                    {isAragUser(props.user.loggedInUser.roles) &&
                      ( SHOW_APPLICATION_PREMIUM_STATUSES.includes(props.Store.selectedApplication.policyStatusMachineName)) 
                      ? (
                      <div>
                        <CustomModal
                          contentClassname={"premiumSettingsWizard__modal"}
                          isOpen={props.isEditModalOpen}
                          handleClose={props.closeEditModal}
                          content={
                            <ApplicationPremiumSettingsHOC
                              onEditStaged={props.openEditModal}
                              isEditStaged={props.isEditModalOpen}
                              isChangingStatusOfApp={false}
                              showTable={false}
                              isEditMode={true}
                              isApplicationPremium={true}
                              applicationPremiumSaveButtonLabel={"Save changes"}
                              applicationPremiumCancelHandler={props.closeEditModal}
                              selectedApplicationCaseTypeId={props.Store.selectedApplication.caseTypeId}
                              onCancel={props.closeEditModal}
                            />
                          }
                        />
                        {!props.isEditModalOpen &&
                          (
                            <div>
                              <HorizontalRule />
                              <ApplicationPremiumSettingsHOC
                                isChangingStatusOfApp={false}
                                showTable={true}
                                isEditMode={false}
                                isApplicationPremium={true}
                                applicationPremiumCancelHandler={() => null}
                                selectedApplicationCaseTypeId={props.Store.selectedApplication.caseTypeId}
                                onApplicationPremiumEdit={props.openEditModal}
                                onCancel={props.closeEditModal}
                                onEditStaged={props.openEditModal}
                                isEditStaged={props.isEditModalOpen}
                              />
                            </div>
                          )}
                      </div>
                    ) : null}
              </div>
            ) : null}
            {((props.Store.showForm && !props.Store.fetching) ||
              (Object.keys(props.Store.selectedApplication).length !== 0 &&
                props.Store.selectedApplication.constructor === Object &&
                props.Store.selectedApplication.draft &&
                !props.Store.fetching &&
                isSolicitorUser(props.user.loggedInUser.roles))) &&
            Object.keys(props.Store.application).length !== 0 &&
            props.Store.application.constructor === Object ? (
              <FullApplicationForm
                {...props}
                caseTypeOptions={caseTypeOptions}
                subCaseTypeOptions={subCaseTypeOptions}
                maxDateOfBirth={maxDateOfBirth}
                workSourceOptions={workSourceOptions}
              />
            ) : props.Store.fetching ? (
              <div className="form-group">
                <div className="col-sm-12">
                  <CenteredDots />
                </div>
              </div>
            ) : (
              <div>
                {!props.Store.referralExists && (
                  <FormResponseMessage
                    CenterWrapper="col-sm-12"
                    MessageStyle="formResponseMessage-reject"
                    Message={
                      "No application referral setting exists for the selected combination of case type and sub case type."
                    }
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewApplication;
